import React from 'react';
import { theme } from '../../constants/theme';
import { Box, Grid, Skeleton } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';

const SuggestedContestsShimmer = () => {
    const { themeStyle } = useThemeContext();
    const rowCount = 5;

    return (
        <Grid item xs={12} md={12} lg={4} sx={{ display: { xs: 'none', md: 'block' } }}>
            <Box
                sx={{
                    backgroundColor: theme[themeStyle].deep_grey,
                    borderRadius: 3,
                    overflow: 'hidden',
                    border: '1px solid rgba(255,255,255,0.06)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.22)',
                }}>
                <Box
                    sx={{
                        px: 3,
                        py: 2.5,
                        borderBottom: '1px solid rgba(255,255,255,0.06)',
                    }}>
                    <Skeleton
                        variant="text"
                        sx={{
                            width: 190,
                            height: 32,
                            backgroundColor: theme[themeStyle].gray_text,
                        }}
                    />
                </Box>

                <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.75 }}>
                    {Array.from(new Array(rowCount)).map((_, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                p: 1.5,
                                borderRadius: 2,
                                backgroundColor: theme[themeStyle].deep_grey_lighter,
                            }}>
                            <Skeleton
                                variant="rounded"
                                sx={{
                                    width: 80,
                                    height: 80,
                                    borderRadius: 1.5,
                                    flexShrink: 0,
                                    backgroundColor: theme[themeStyle].gray_text,
                                }}
                            />
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Skeleton
                                    variant="text"
                                    sx={{
                                        width: '70%',
                                        height: 20,
                                        backgroundColor: theme[themeStyle].gray_text,
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    sx={{
                                        width: '100%',
                                        height: 16,
                                        mt: 0.5,
                                        backgroundColor: theme[themeStyle].darkGray60,
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    sx={{
                                        width: '92%',
                                        height: 16,
                                        backgroundColor: theme[themeStyle].darkGray60,
                                    }}
                                />
                                <Skeleton
                                    variant="text"
                                    sx={{
                                        width: 90,
                                        height: 16,
                                        mt: 0.6,
                                        backgroundColor: theme[themeStyle].darkGray60,
                                    }}
                                />
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Grid>
    );
};
export { SuggestedContestsShimmer };
